module.exports = __webpack_public_path__ + "static/img/u951.f72684c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u951.svg
// module id = k6BW
// module chunks = 209